import { render, staticRenderFns } from "./List-Promotion-Online.vue?vue&type=template&id=5c998bf9&scoped=true"
import script from "./List-Promotion-Online.vue?vue&type=script&lang=js"
export * from "./List-Promotion-Online.vue?vue&type=script&lang=js"
import style0 from "./List-Promotion-Online.vue?vue&type=style&index=0&id=5c998bf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c998bf9",
  null
  
)

export default component.exports